/**
 * Reusable back button component for login flow steps
 */
import React from "react"
import ArrowLeft from "@/components/icons/arrowLeft"
import styles from "../styles/login.module.scss"

interface BackButtonProps {
  onClick: () => void
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={styles["back-button"]}
      aria-label="Go back"
    >
      <ArrowLeft width={20} height={20} />
    </button>
  )
}

export default BackButton

